"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("./styled");
const HeroButton = ({ to, large, onClick, children }) => ((0, jsx_runtime_1.jsx)(styled_1.StyledCTA, { buttonTheme: "upgrade", large: large, to: to, onClick: onClick, children: children }));
exports.HeroButton = HeroButton;
